import {
  AfterContentInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  ViewChild,
  SimpleChanges,
  EventEmitter,
  Inject,
  Injectable
} from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
/**
 * You may include a different variant of BpmnJS:
 *
 * bpmn-viewer  - displays BPMN diagrams without the ability
 *                to navigate them
 * bpmn-modeler - bootstraps a full-fledged BPMN editor
 */
import { importDiagram } from 'src/app/shared/services/bpmn-import';
import { throwError, Observable } from 'rxjs';
import { Modeler } from "src/app/shared/interfaces/bpmn-js";
import spanishTranslate from 'src/app/shared/providers/bpmn-props/CustomTranslate';
import { TranslateService } from "@ngx-translate/core";
import { EventBusLogger } from 'src/app/shared/providers/bpmn-props/EventBusLogger';
import { is } from 'bpmn-js/lib/util/ModelUtil';
@Component({
  selector: 'app-flowchart',
  templateUrl: './flowchart.component.html',
  styleUrls: ['./flowchart.component.scss']
})
@Injectable()

export class FlowchartComponent implements  AfterContentInit, OnChanges, OnDestroy {
  private bpmnJS;
  private eventBus;
  private directEditing;
  savebtn : string = '';
  emptyDiagram: string = './assets/bpmn/initial.bpmn';
  private elementRegistry;
  @ViewChild('ref', {static: true}) private el: ElementRef;
  @Output() private importDone: EventEmitter<any> = new EventEmitter();
  @Output() private saveDone: EventEmitter<any> = new EventEmitter();
  @Output() private onChange: EventEmitter<any> = new EventEmitter();
  @Output() private onCreateProcess: EventEmitter<any> = new EventEmitter();
  @Output() private resizeDone: EventEmitter<any> = new EventEmitter();
  @Input() clear: boolean = false;
  @Input() elementChanged: string = null;
  @Input() private url: string;
  constructor(private http: HttpClient, private translate: TranslateService) {

    const addModule = this.translate.currentLang == 'es' ?
     [
      {
        __init__: ["eventBusLogger"],
        eventBusLogger: ["type", EventBusLogger]
      },
      {
        translate: [ 'value', spanishTranslate ]
      }
    ] : [
      {
        __init__: ["eventBusLogger"],
        eventBusLogger: ["type", EventBusLogger]
      }
    ];
    this.bpmnJS = new Modeler({
      keyboard: {
        bindTo: document
      },
      additionalModules: addModule
    });
    this.elementRegistry =  this.bpmnJS.get('elementRegistry');
    this.directEditing = this.bpmnJS.get('directEditing');
    this.bpmnJS.on('import.done', ({ error }) => {
      if (!error) {
        this.bpmnJS.get('canvas').zoom('fit-viewport');
      }
    });
    this.eventBus = this.bpmnJS.get('eventBus');
    this.eventBus.on(['create.end', 'autoPlace.end'], (context) => {
      const { shape } = context;
       if( shape.type === 'bpmn:Task'){
        this.directEditing.cancel();
        const list = this.elementRegistry.getAll();
        this.onCreateProcess.emit({
          event,
          element: shape,
          list
        });
       }
    });

    this.eventBus.on('element.changed', (context) => {
      const { element } = context;
      if( element.type === 'bpmn:Task'){
        this.directEditing.cancel();
      }
      if (!context.noBind) {
        const list = this.elementRegistry.getAll();
        this.onChange.emit({
          event,
          element,
          list
        });
      };
    });
    this.savebtn = this.translate.instant("flowchart.save");
  }

  resize(){
    this.resizeDone.emit({
      type: 'maximize'
    });
  }

  ngAfterContentInit(): void {
    this.bpmnJS.attachTo(this.el.nativeElement);
  }

  ngOnChanges(changes: SimpleChanges) {
    // re-import whenever the url changes
    if (changes.url) {
      if (!this.url)
        this.loadUrl(this.emptyDiagram);
      else
        this.loadUrl(changes.url.currentValue);
    }
    if(changes.clear){
       if (this.clear){
        this.bpmnJS.clear();
        this.loadUrl(this.emptyDiagram);
       }
    }
    if(changes.elementChanged){
      if(!!this.elementChanged){
        console.log('fire changed')
        const el = this.elementRegistry.get(this.elementChanged);
        console.log(this.elementChanged);

        this.eventBus.fire('element.changed', { element: el, noBind: true });
      }
    }
  }

  ngOnDestroy(): void {
    this.bpmnJS.destroy();
  }

  /**
   * Load diagram from URL and emit completion event
   */
  loadUrl(url: string) {
    let header = new HttpHeaders({
      "Accept":"application/xml",
      "Content-Type":"application/xml"
    })
    return (
      this.http.get(url, { headers: header, responseType: 'text' }).pipe(
        catchError(err => throwError(err)),
        importDiagram(this.bpmnJS)
      ).subscribe(
        (warnings) => {
          const list = this.elementRegistry.getAll();
          this.importDone.emit({
            type: 'success',
            warnings,
            list
          });
        },
        (err) => {
          this.importDone.emit({
            type: 'error',
            error: err
          });
        }
      )
    );
  }
  save(): void {
    this.bpmnJS.saveXML((err: any, xml: any) => {
      console.log('Result of saving XML: ', err, xml);
      if(!err){
        this.bpmnJS.saveSVG((e: any, svg: any) => {
          console.log('Result of saving SVG: ', e, svg);
          if(!e){
            this.saveDone.emit({
              type: 'success',
              xml,
              svg
            });
          } else {
            this.saveDone.emit({
              type: 'error',
              error: e
            });
          }
          //const blob = new Blob([svg], {type: 'text/plain;charset=utf-8'});
          //const encodedData =  btoa(svg);
          //FileSaver.saveAs(blob, 'bpmnSample.svg');
        });

      } else {
        this.saveDone.emit({
          type: 'error',
          error: err
        });
      }
    });
  }

}
